module.exports = __webpack_public_path__ + "a6522dc754ae8efe91665d0ba7905489.svg";